import { PLAN_TIERS, type PlanTierId } from '@super/shared-types'
import { cn } from '@/lib/utils'
import { PlanTierCard } from './PlanTierCard'
import { CONTACT_SALES_MAILTO } from '../sales'

export type PickerSelection = PlanTierId | 'contact-sales' | null

interface PlanPickerPanelProps {
  selectedTierId: PickerSelection
  recommendedTierId: PickerSelection
  onSelect: (id: PlanTierId) => void
}

export function PlanPickerPanel({
  selectedTierId,
  recommendedTierId,
  onSelect,
}: PlanPickerPanelProps) {
  const contactSalesSelected = selectedTierId === 'contact-sales'
  const contactSalesRecommended = recommendedTierId === 'contact-sales'

  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
      {PLAN_TIERS.map(tier => (
        <PlanTierCard
          key={tier.id}
          tier={tier}
          selected={tier.id === selectedTierId}
          recommended={tier.id === recommendedTierId}
          onSelect={() => onSelect(tier.id)}
        />
      ))}

      <a
        href={CONTACT_SALES_MAILTO}
        aria-pressed={contactSalesSelected}
        className={cn(
          'group relative flex flex-col items-start gap-2 rounded-lg border p-4 text-left transition-all duration-200',
          'hover:-translate-y-0.5',
          contactSalesSelected
            ? 'border-slate-400 bg-slate-100 ring-2 shadow-sm ring-slate-300 dark:border-slate-700 dark:bg-slate-900/50'
            : 'border-border hover:border-foreground/40 border-dashed',
        )}
      >
        {contactSalesRecommended ? (
          <span className="bg-foreground text-background font-fragment-mono absolute -top-2 right-3 rounded-full px-2 py-0.5 text-[9px] uppercase tracking-[0.12em]">
            Best fit
          </span>
        ) : null}
        <span className="font-space-grotesk text-lg font-semibold tracking-tight">
          3,000+ minutes
        </span>
        <span className="text-muted-foreground text-xs">
          Bespoke bundle at custom pricing.
        </span>
        <span className="text-foreground text-xs font-medium">
          Contact sales →
        </span>
        <span className="text-muted-foreground mt-auto text-[10px]">
          Super responds in under 30 minutes
        </span>
      </a>
    </div>
  )
}
